export default "__VITE_ASSET__By0KWjx8__"